export enum EntryFormEnum {
	ENTRADA_SIMPLIFICADA = 'entrada_simplificada',
	ENEM = 'enem',
	VESTIBULAR_TRADICIONAL = 'vestibular_tradicional',
	TRANSFERENCIA = 'transferencia',
	SEGUNDA_GRADUACAO = 'segunda_graduacao',
}

export function getTextEntryForm(entry_form: EntryFormEnum): string {
    switch (entry_form) {
        case EntryFormEnum.ENTRADA_SIMPLIFICADA:
            return 'Vestibular Simplificado';
        case EntryFormEnum.ENEM:
            return 'Enem';
        case EntryFormEnum.VESTIBULAR_TRADICIONAL:
            return 'Vestibular Tradicional';
		case EntryFormEnum.TRANSFERENCIA:
            return 'Transferência';
		case EntryFormEnum.SEGUNDA_GRADUACAO:
            return 'Segunda Graduação';
        default:
            return entry_form;
    }
}
